import * as lib from '../api/templates.js';
import { APIBASE } from '../config.js';
import { fetchLoadable } from '../fetchLoadable.js';
import * as actionTypes from './actionTypes.js';
export const getAll = () => fetchLoadable(actionTypes.FETCH_TEMPLATES, lib.getAll);
export const genPreviewUrl = (templateId, caseId, versionId, data) => `${APIBASE}/collection-engine/preview/letter?content=${encodeURIComponent(JSON.stringify({ data, caseId, templateId, versionId }))}`;
//# sourceMappingURL=actions.js.map